//
//
//
//
//
//
//
//
//
//
//

import VueContentLoader from "vue-content-loading";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ManageEmailCalendarsModalLoader",
  components: {
    VueContentLoader
  }
});